import { fromJS, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import { msg } from '@gonfalon/messages/msg';

import { type AccessReason } from '../types';

type AccessDecisionType = {
  isAllowed: boolean;
  appliedRoleName: string;
  isServiceToken: boolean;
  customMessage: string;
  reason: AccessReason;
};

export class AccessDecision extends Record<AccessDecisionType>({
  isAllowed: true,
  reason: Map(),
  appliedRoleName: '',
  isServiceToken: false,
  customMessage: '',
}) {
  getActionReason() {
    if (this.customMessage) {
      return this.customMessage;
    }

    if (!this.isAllowed) {
      return this.appliedRoleName
        ? msg('access.reason.roleCannotPerformAction', { roleName: this.appliedRoleName })
        : msg('access.reason.cannotPerformAction');
    }
    return '';
  }

  getModifyFieldReason() {
    if (this.customMessage) {
      return this.customMessage;
    }
    if (!this.isAllowed) {
      return this.appliedRoleName
        ? msg('access.reason.roleCannotModifyField', { roleName: this.appliedRoleName })
        : msg('access.reason.cannotModifyField');
    }
    return '';
  }

  getChangeSettingReason() {
    if (this.customMessage) {
      return this.customMessage;
    }
    if (!this.isAllowed) {
      return this.appliedRoleName
        ? msg('access.reason.roleCannotChangeSetting', { roleName: this.appliedRoleName })
        : msg('access.reason.cannotChangeSetting');
    }
    return '';
  }

  getServiceTokenReason() {
    if (this.customMessage) {
      return this.customMessage;
    }
    return this.isServiceToken ? msg('access.reason.serviceTokenRoles') : '';
  }
}

export function createAccessDecision(props = {}) {
  if (props instanceof AccessDecision) {
    return props;
  }
  return new AccessDecision(fromJS(props));
}
